module.exports = __webpack_public_path__ + "static/media/2639_2019Gallery.3dd8bdef.JPG";